/* Mega menú de «Shop» — opción A del lote del 7-oct-2026
   (docs/superpowers/specs/2026-10-07-mega-menu-a-y-escaparate-c-design.md; prototipo
   docs/prototipos/2026-10-07-mega-menu/).

   PC (≥1100): el panel bajo «Shop» se abre al pasar el ratón (con un poco de intención), con el botón ▾
   o con el teclado. A la izquierda las categorías, con un resalte que se desliza; a la derecha, la ficha
   de la categoría bajo el ratón: botones, logos de marcas y su más vendido, que cambia al pasar por
   cada logo. Con el Tab se recorre categoría → su ficha → la siguiente categoría…; las flechas ↑ ↓
   saltan de categoría y Escape cierra.
   Celular: «Shop» en el menú de la hamburguesa abre dos pantallas que entran desde la derecha
   (categorías → categoría). Lo de debajo queda inert para que el foco no se escape.

   Las fichas salen de sections/gyaa-mega-menu.liquid, que se pide una sola vez con la Section
   Rendering API y se guarda 10 minutos en sessionStorage: el header no las pinta en cada página. */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var CACHE_MS = 10 * 60 * 1000;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- Contenido (Section Rendering API + caché de la sesión) ------------- */

  var src = (function () {
    var el = document.querySelector('[data-mm-src]');
    var raiz = el ? el.getAttribute('data-mm-src') : '/';
    return raiz.replace(/\/?$/, '/') + '?section_id=gyaa-mega-menu';
  })();
  var contenido = null;
  var pedido = null;

  function claveCache() {
    var tema = window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : '';
    return 'gyaa-mm:' + tema + ':' + src;
  }

  function leerCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(claveCache()) || 'null');
      if (c && Date.now() - c.t < CACHE_MS) return c.html;
    } catch (e) { /* sin sessionStorage: se pide */ }
    return null;
  }

  function cargar() {
    if (contenido) return Promise.resolve(contenido);
    if (pedido) return pedido;
    var html = leerCache();
    var texto = html ? Promise.resolve(html) : fetch(src, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('mega menú: ' + r.status);
      return r.text();
    }).then(function (txt) {
      try { sessionStorage.setItem(claveCache(), JSON.stringify({ t: Date.now(), html: txt })); } catch (e) { /* lleno o bloqueado */ }
      return txt;
    });
    pedido = texto.then(function (txt) {
      var c = new DOMParser().parseFromString(txt, 'text/html').querySelector('[data-mm-contenido]');
      if (!c) throw new Error('mega menú: sin contenido');
      contenido = c;
      return c;
    }).catch(function (e) {
      pedido = null;
      try { sessionStorage.removeItem(claveCache()); } catch (er) { /* nada */ }
      throw e;
    });
    return pedido;
  }

  function ficha(h) {
    if (!contenido) return null;
    var fichas = contenido.querySelectorAll('[data-mm-cat]');
    for (var i = 0; i < fichas.length; i++) {
      if (fichas[i].getAttribute('data-mm-cat') === h) return fichas[i];
    }
    return null;
  }

  /* Mientras llega el contenido: la cabecera de la categoría y huecos que brillan. */
  function esqueleto(origen) {
    var s = document.createElement('section');
    s.className = 'mm-cat mm-cat--cargando';
    s.setAttribute('aria-busy', 'true');
    s.innerHTML =
      '<div class="mm-cat__head"><h2 class="mm-cat__title"></h2><a class="mm-cat__cta"></a></div>' +
      '<div class="mm-cat__body"><div class="mm-cat__marcas"><div class="mm-cat__grid">' +
      new Array(9).join('<span class="mm-tile mm-tile--hueco"></span>') +
      '</div></div><span class="mm-spot mm-spot--hueco"></span></div>';
    s.querySelector('.mm-cat__title').textContent = origen.getAttribute('data-mm-titulo') || '';
    var a = s.querySelector('.mm-cat__cta');
    a.href = origen.getAttribute('data-mm-url') || origen.getAttribute('href') || '#';
    a.textContent = origen.getAttribute('data-mm-ver') || '';
    return s;
  }

  function entra(el, dy) {
    if (!el || reducido.matches || !el.animate) return;
    el.animate(
      [{ opacity: 0, transform: 'translateY(' + (dy || 6) + 'px)' }, { opacity: 1, transform: 'none' }],
      { duration: 220, easing: EASE }
    );
  }

  function poner(destino, nodo) {
    while (destino.firstChild) destino.removeChild(destino.firstChild);
    destino.appendChild(nodo);
  }

  function enfocables(el) {
    return Array.prototype.filter.call(el.querySelectorAll('a[href], button:not([disabled])'), function (x) {
      return x.offsetWidth > 0 || x.offsetHeight > 0;
    });
  }

  /* El destacado sigue al logo bajo el ratón (o con el foco) y vuelve al más vendido de la categoría. */
  function montarDestacado(f) {
    var spot = f.querySelector('[data-mm-spot-el]');
    var base = f.querySelector('template[data-mm-spot-cat]');
    var grid = f.querySelector('[data-mm-grid]');
    if (!spot || !base || !grid) return;
    var tiles = grid.querySelectorAll('[data-mm-tile]');
    var actual = base;
    var volver = null;

    function mostrarTpl(tpl, tile) {
      clearTimeout(volver);
      Array.prototype.forEach.call(tiles, function (t) { t.classList.toggle('is-hover', t === tile); });
      if (actual === tpl) return;
      actual = tpl;
      spot.innerHTML = tpl.innerHTML;
      spot.setAttribute('href', tpl.getAttribute('data-href'));
      entra(spot.querySelector('.mm-prod__fig'), 8);
    }

    Array.prototype.forEach.call(tiles, function (t) {
      var tpl = grid.querySelector('template[data-mm-spot="' + t.getAttribute('data-mm-tile') + '"]') || base;
      t.addEventListener('mouseenter', function () { mostrarTpl(tpl, t); });
      t.addEventListener('focus', function () { mostrarTpl(tpl, t); });
    });
    grid.addEventListener('mouseleave', function () {
      volver = setTimeout(function () { mostrarTpl(base, null); }, 160);
    });
    grid.addEventListener('focusout', function (e) {
      if (!grid.contains(e.relatedTarget)) mostrarTpl(base, null);
    });
  }

  /* --- PC: panel bajo «Shop» ------------------------------------------------ */

  function initPC() {
    var caja = document.querySelector('.gyaa-header .gyaa-nav-shop');
    var panel = document.querySelector('[data-mm-panel]');
    var btn = document.querySelector('[data-mm-btn]');
    if (!caja || !panel || !btn || panel.dataset.mmBound) return;
    panel.dataset.mmBound = '1';
    var main = panel.querySelector('[data-mm-main]');
    var cats = Array.prototype.slice.call(panel.querySelectorAll('.gyaa-mm__cat'));
    var hl = panel.querySelector('.gyaa-mm__hl');
    var velo = document.querySelector('[data-mm-velo]');
    var mqPC = window.matchMedia('(min-width: 1100px)');
    var mqRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
    var abierto = false;
    var tAbrir = null;
    var tCerrar = null;
    var tCat = null;
    var visto = null; // handle de la ficha que se ve
    var activo = cats.filter(function (a) { return a.classList.contains('is-active'); })[0] || cats[0];
    if (!main || !activo) return;

    /* El panel cabe en la pantalla: la columna de categorías y la ficha hacen scroll por su cuenta */
    function ajustarAlto() {
      var top = panel.getBoundingClientRect().top;
      panel.style.setProperty('--mm-alto', Math.max(320, window.innerHeight - top - 16) + 'px');
    }

    function mostrar(a, animar) {
      if (!a) return;
      activo = a;
      cats.forEach(function (c) { c.classList.toggle('is-active', c === a); });
      if (hl) hl.style.transform = 'translateY(' + a.parentNode.offsetTop + 'px)';
      var h = a.getAttribute('data-mm-cat');
      if (visto === h) return;
      var f = ficha(h);
      var nuevo;
      if (f) {
        nuevo = f.cloneNode(true);
        visto = h;
      } else {
        nuevo = esqueleto(a);
        visto = null;
        cargar().then(function () {
          if (abierto && activo === a) mostrar(a, true);
        }).catch(function () { /* se queda la cabecera con «Shop all» */ });
      }
      poner(main, nuevo);
      main.scrollTop = 0;
      if (f) montarDestacado(nuevo);
      if (animar) entra(nuevo, 6);
    }

    function abrir() {
      clearTimeout(tCerrar);
      clearTimeout(tAbrir);
      if (abierto || !mqPC.matches) return;
      abierto = true;
      cargar().catch(function () { /* se ve el esqueleto */ });
      panel.classList.add('is-visible');
      if (velo) velo.classList.add('is-visible');
      ajustarAlto();
      mostrar(activo, false);
      void panel.offsetWidth; // para que la transición arranque desde el estado cerrado
      panel.classList.add('is-open');
      if (velo) velo.classList.add('is-open');
      caja.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function cerrar(devolverFoco) {
      clearTimeout(tAbrir);
      clearTimeout(tCerrar);
      if (!abierto) return;
      abierto = false;
      panel.classList.remove('is-open');
      if (velo) velo.classList.remove('is-open');
      caja.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      var fin = function () {
        if (abierto) return;
        panel.classList.remove('is-visible');
        if (velo) velo.classList.remove('is-visible');
      };
      if (reducido.matches) fin();
      else setTimeout(fin, 200);
      if (devolverFoco) btn.focus();
    }

    /* Ratón: abre con 90 ms de intención y cierra con 260 ms de margen (el puente del panel tapa el hueco) */
    caja.addEventListener('mouseenter', function () {
      if (!mqRaton.matches) return;
      clearTimeout(tCerrar);
      tAbrir = setTimeout(abrir, 90);
    });
    caja.addEventListener('mouseleave', function () {
      clearTimeout(tAbrir);
      if (abierto) tCerrar = setTimeout(function () { cerrar(false); }, 260);
    });
    btn.addEventListener('click', function () {
      if (abierto) cerrar(false);
      else abrir();
    });

    /* Precarga: en cuanto el ratón entra en el menú o el foco llega a «Shop» */
    var nav = caja.parentNode || caja;
    nav.addEventListener('mouseenter', function () {
      if (mqPC.matches) cargar().catch(function () { /* se reintenta al abrir */ });
    });
    caja.addEventListener('focusin', function () { cargar().catch(function () { /* idem */ }); });

    cats.forEach(function (a, n) {
      a.addEventListener('mouseenter', function () {
        clearTimeout(tCat);
        tCat = setTimeout(function () { mostrar(a, true); }, 70);
      });
      a.addEventListener('mouseleave', function () { clearTimeout(tCat); });
      a.addEventListener('focus', function () {
        clearTimeout(tCat);
        mostrar(a, true);
      });
      a.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Home' || k === 'End') {
          e.preventDefault();
          var m = k === 'Home' ? 0 : k === 'End' ? cats.length - 1 : (n + (k === 'ArrowDown' ? 1 : -1) + cats.length) % cats.length;
          cats[m].focus();
        } else if ((k === 'Tab' && !e.shiftKey) || k === 'ArrowRight') {
          /* Tab: de la categoría a su ficha */
          var lista = enfocables(main);
          if (lista.length) {
            e.preventDefault();
            lista[0].focus();
          }
        } else if (k === 'Tab' && e.shiftKey && n > 0) {
          /* Mayús+Tab: al final de la ficha de la categoría anterior */
          e.preventDefault();
          mostrar(cats[n - 1], false);
          var previa = enfocables(main);
          (previa[previa.length - 1] || cats[n - 1]).focus();
        }
      });
    });

    main.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var lista = enfocables(main);
      var i = lista.indexOf(document.activeElement);
      var n = cats.indexOf(activo);
      if (!e.shiftKey && i === lista.length - 1 && n < cats.length - 1) {
        /* Fin de la ficha: a la categoría siguiente */
        e.preventDefault();
        cats[n + 1].focus();
      } else if (e.shiftKey && i === 0) {
        e.preventDefault();
        activo.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && abierto) cerrar(caja.contains(document.activeElement));
    });
    caja.addEventListener('focusout', function (e) {
      if (abierto && e.relatedTarget && !caja.contains(e.relatedTarget)) cerrar(false);
    });
    document.addEventListener('click', function (e) {
      if (abierto && !caja.contains(e.target)) cerrar(false);
    });
    var cambio = function () { if (!mqPC.matches) cerrar(false); };
    if (mqPC.addEventListener) mqPC.addEventListener('change', cambio);
    else if (mqPC.addListener) mqPC.addListener(cambio);
    window.addEventListener('resize', function () { if (abierto) ajustarAlto(); });
  }

  /* --- Celular: pantallas dentro del menú de la hamburguesa ------------------ */

  function initMovil() {
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!overlay) return;
    var abrirBtn = overlay.querySelector('[data-mm-mo-abrir]');
    var capa1 = overlay.querySelector('[data-mm-capa="1"]');
    var capa2 = overlay.querySelector('[data-mm-capa="2"]');
    if (!abrirBtn || !capa1 || !capa2 || capa1.dataset.mmBound) return;
    capa1.dataset.mmBound = '1';
    var cuerpo = capa2.querySelector('[data-mm-capa-cuerpo]');
    var base = ['.gyaa-menu-overlay__top', '.gyaa-menu-overlay__nav', '.gyaa-menu-overlay__bottom']
      .map(function (s) { return overlay.querySelector(s); })
      .filter(Boolean);
    var catBtn = null;

    function inerte(els, si) {
      els.forEach(function (el) { el.inert = si; });
    }

    function abrirCapa(capa, debajo) {
      capa.hidden = false;
      void capa.offsetWidth;
      capa.classList.add('is-open');
      inerte(debajo, true);
      capa.scrollTop = 0;
      var volver = capa.querySelector('[data-mm-volver]');
      if (volver) volver.focus({ preventScroll: true });
    }

    function cerrarCapa(capa, debajo, foco) {
      capa.classList.remove('is-open');
      inerte(debajo, false);
      var fin = function () { if (!capa.classList.contains('is-open')) capa.hidden = true; };
      if (reducido.matches) fin();
      else setTimeout(fin, 320);
      if (foco) foco.focus({ preventScroll: true });
    }

    function pintarCat(b) {
      var f = ficha(b.getAttribute('data-mm-cat'));
      poner(cuerpo, f ? f.cloneNode(true) : esqueleto(b));
      if (!f) {
        cargar().then(function () {
          if (catBtn === b && capa2.classList.contains('is-open')) pintarCat(b);
        }).catch(function () { /* se queda la cabecera con «Shop all» */ });
      }
    }

    abrirBtn.addEventListener('click', function () {
      cargar().catch(function () { /* se ve el esqueleto */ });
      abrirBtn.setAttribute('aria-expanded', 'true');
      abrirCapa(capa1, base);
    });
    capa1.querySelector('[data-mm-volver]').addEventListener('click', function () {
      abrirBtn.setAttribute('aria-expanded', 'false');
      cerrarCapa(capa1, base, abrirBtn);
    });
    Array.prototype.forEach.call(capa1.querySelectorAll('button[data-mm-cat]'), function (b) {
      b.addEventListener('click', function () {
        catBtn = b;
        pintarCat(b);
        abrirCapa(capa2, [capa1]);
      });
    });
    capa2.querySelector('[data-mm-volver]').addEventListener('click', function () {
      cerrarCapa(capa2, [capa1], catBtn);
    });

    /* La X de cada pantalla cierra el menú entero (el de global.js) */
    Array.prototype.forEach.call(overlay.querySelectorAll('[data-mm-cerrar]'), function (x) {
      x.addEventListener('click', function () {
        inerte(base.concat([capa1]), false);
        var c = overlay.querySelector('[data-menu-close]');
        if (c) c.click();
      });
    });

    /* Al cerrarse el menú (X, Escape, «More»), todo vuelve al principio */
    new MutationObserver(function () {
      if (!overlay.hidden) return;
      [capa1, capa2].forEach(function (c) {
        c.classList.remove('is-open');
        c.hidden = true;
      });
      inerte(base.concat([capa1]), false);
      abrirBtn.setAttribute('aria-expanded', 'false');
    }).observe(overlay, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init() {
    initPC();
    initMovil();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* En el editor de temas, el header se vuelve a pintar al cambiar un ajuste */
  document.addEventListener('shopify:section:load', init);
})();
